import * as tslib_1 from "tslib";
import { Logger } from '@services/logger/abstract.logger';
import { MapperService } from '@services/mapper.service';
import { UserStateManager } from 'main/app-state/generics/user-state-manager';
import { BehaviorSubject, Observable, } from 'rxjs';
import { distinctUntilChanged, map, tap, } from 'rxjs/operators';
import { SettingsService } from './settings.service';
import { BOOLEAN_SETTINGS, NUMERIC_SETTINGS, STRING_SETTINGS, } from './settings.types';
var SettingsManager = /** @class */ (function (_super) {
    tslib_1.__extends(SettingsManager, _super);
    function SettingsManager(injector, user) {
        var _this = _super.call(this, user) || this;
        _this._state = new BehaviorSubject(null);
        _this._settingsService = injector.get(SettingsService);
        // The Injector doesn't work directly with abstract classes, so manual casting to Type<Logger> has to be done.
        // More details: https://github.com/angular/angular/issues/23611
        _this._logStateChanges('Settings', injector.get(Logger));
        return _this;
    }
    Object.defineProperty(SettingsManager.prototype, "passwordComplexity", {
        get: function () {
            return this._getMappedPropertyFromState('PasswordComplexity', MapperService.passwordComplexityMapper, this.value);
        },
        enumerable: true,
        configurable: true
    });
    SettingsManager.prototype.get$ = function (property) {
        var _this = this;
        return this._state.pipe(map(function (state) { return _this.get(property, state); }), distinctUntilChanged());
    };
    SettingsManager.prototype.get = function (property, state) {
        if (state === void 0) { state = this.value; }
        if (STRING_SETTINGS.includes(property)) {
            return this._getPropertyFromState(property, state);
        }
        if (BOOLEAN_SETTINGS.includes(property)) {
            return this._getBooleanPropertyFromState(property, state);
        }
        if (NUMERIC_SETTINGS.includes(property)) {
            return this._getNumericPropertyFromState(property, state);
        }
        return undefined;
    };
    SettingsManager.prototype.isFeatureEnabled = function (feature) {
        return this._getBooleanPropertyFromState(feature, this.value) || false;
    };
    SettingsManager.prototype.fetch = function () {
        var _this = this;
        return this._settingsService.get()
            .pipe(tap(function (data) { return _this._state.next(data); }));
    };
    SettingsManager.prototype.clean = function () {
        var _this = this;
        return new Observable(function (subscriber) {
            _this._state.next(null);
            subscriber.next(null);
            subscriber.complete();
        });
    };
    SettingsManager.prototype._getPropertyFromState = function (property, state) {
        return state && state.hasOwnProperty(property) ?
            state[property].toString() :
            undefined;
    };
    SettingsManager.prototype._getNumericPropertyFromState = function (property, state) {
        return state && state.hasOwnProperty(property) ?
            Number(state[property]) :
            undefined;
    };
    SettingsManager.prototype._getBooleanPropertyFromState = function (property, state) {
        return state && state.hasOwnProperty(property) ?
            state[property].toLowerCase() === 'true' :
            undefined;
    };
    SettingsManager.prototype._getMappedPropertyFromState = function (property, mapper, state) {
        return state && state.hasOwnProperty(property) ?
            mapper(state[property]) :
            undefined;
    };
    return SettingsManager;
}(UserStateManager));
export { SettingsManager };
